import { NonWorkingTimeConfig } from "@bryntum/schedulerpro";

export const nonWorkingTimeFeature = {
    hideRangesOnZooming: false,
} satisfies Partial<NonWorkingTimeConfig>;
